import { render, staticRenderFns } from "./av_commentary.vue?vue&type=template&id=d6962896&scoped=true&"
import script from "./av_commentary.vue?vue&type=script&lang=js&"
export * from "./av_commentary.vue?vue&type=script&lang=js&"
import style0 from "./av_commentary.vue?vue&type=style&index=0&id=d6962896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6962896",
  null
  
)

export default component.exports